import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { headerHeight } from '../helpers';
import breakpoints from '../../../_src/config/breakpoints.json';

gsap.registerPlugin(ScrollTrigger);

export const initScrollingText = () => {
  const scrollingTextContainers = document.querySelectorAll('[data-scrolling-text]:not(.gsap-initialized)');
  scrollingTextContainers.forEach((scrollingText) => {
    const scrollingTextContent = scrollingText.querySelector('[data-scrolling-text-content]');
    if (scrollingTextContent) {
      scrollingTextContent.innerHTML = `${scrollingTextContent.innerHTML.trim()}&nbsp;`;
      while (scrollingText.clientWidth < window.innerWidth * 2) {
        const secondScrolling = scrollingTextContent.cloneNode(true);
        scrollingText.appendChild(secondScrolling);
      }
      gsap.to(scrollingText, {
        xPercent: 0,
        scrollTrigger: {
          ease: 'easing.Linear',
          trigger: scrollingText,
          start: '-50% bottom',
          end: '150% top',
          scrub: 1,
          markers: false
        }
      });
      scrollingText.classList.add('gsap-initialized');
    }
  });
};

export const initPinnedElements = () => {
  document.querySelectorAll('[data-pinned-elements]:not(.gsap-initialized)').forEach((pinnedElementsContainer) => {
    pinnedElementsContainer.querySelectorAll('[data-pin]').forEach((pinEelement) => {
      if (typeof pinEelement.dataset.pinBreakpoint !== 'undefined') {
        const mm = gsap.matchMedia();
        mm.add(`(min-width: ${breakpoints[0][pinEelement.dataset.pinBreakpoint]})`, () => {
          ScrollTrigger.create({
            trigger: pinEelement,
            start: `top ${headerHeight()}`,
            end: `100% ${headerHeight()}`,
            pin: true,
            pinSpacing: false,
            markers: false
          });
        });
      } else {
        ScrollTrigger.create({
          trigger: pinEelement,
          start: `top ${headerHeight()}`,
          end: `100% ${headerHeight()}`,
          pin: true,
          pinSpacing: false,
          markers: false,
          onUpdate: () => {
              if($(pinEelement).css("position")!='fixed'){
                  $(pinEelement).addClass('centered');
              }else {
                $(pinEelement).removeClass('centered');
              }
          }
        });
      }
    });
    pinnedElementsContainer.classList.add('gsap-initialized');
  });
};

export const initMovingElements = () => {
  document.querySelectorAll('[data-moving-elements-container]:not(.gsap-initialized)').forEach((movingElementsContainer) => {
    movingElementsContainer.querySelectorAll('[data-moving-element]').forEach((movingElement) => {
      gsap.fromTo(movingElement,
        {
          xPercent: movingElement.dataset.startX ? movingElement.dataset.startX : 0,
          yPercent: movingElement.dataset.startY ? movingElement.dataset.startY : 0
        },
        {
          xPercent: movingElement.dataset.endX ? movingElement.dataset.endX : 0,
          yPercent: movingElement.dataset.endY ? movingElement.dataset.endY : 0,
          scrollTrigger: {
            ease: 'easing.Linear',
            trigger: movingElement,
            start: typeof movingElement.dataset.animationThreshold !== 'undefined' ? `-${movingElement.dataset.animationThreshold}% bottom` : '-15% bottom',
            end: typeof movingElement.dataset.animationThreshold !== 'undefined' ? `${parseInt(movingElement.dataset.animationThreshold) + 100}% top` : '115% top',
            scrub: 1,
            markers: false
          }
        }
      );
    });
    movingElementsContainer.classList.add('gsap-initialized');
  });
};
